// @flow

import queryString from 'query-string';
import _ from 'lodash';
import { ConnectionError, RequestError } from 'errors';
import 'whatwg-fetch';
import { redirectToLogin } from './utils';
import createError from 'http-errors';
import { NOTIFICATION_API, BASE_URL, MOFUMOBI_URL } from './consts';

const HEADERS = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
};
const CREDENTIALS_MODE = 'include';

function parseJSON(response: Response): Promise<any> {
    if (_.includes(response.headers.get('Content-Type'), 'application/json')) {
        return response.json();
    }
    return Promise.resolve(response);
}

export function del(resource: string, query: ?Object = {}): Promise<any> {
    const qs = queryString.stringify(query);
    return fetch(`${BASE_URL}/${resource}?${qs}`, {
        method: 'DELETE',
        headers: HEADERS,
        credentials: CREDENTIALS_MODE,
    })
        .then(checkStatus)
        .then(parseJSON);
}

export function patch(resource: string, data: ?Object = {}, query: Object = {}): Promise<any> {
    // console.log(resource, data);
    const qs = queryString.stringify(query);
    return fetch(`${BASE_URL}/${resource}?${qs}`, {
        method: 'PATCH',
        headers: HEADERS,
        body: JSON.stringify(data),
        credentials: CREDENTIALS_MODE,
    })
        .then(checkStatus)
        .then(parseJSON);
}

export function post(resource: string, data: any, query: Object = {}): Promise<any> {
    const qs = queryString.stringify(query);
    // console.log(resource, data);
    return fetch(`${BASE_URL}/${resource}?${qs}`, {
        method: 'POST',
        headers: HEADERS,
        body: JSON.stringify(data),
        credentials: CREDENTIALS_MODE,
    })
        .then(checkStatus)
        .then(parseJSON);
}

export function get(resource: string, query: Object = {}): Promise<any> {
    const qs = queryString.stringify(query);
    return fetch(`${BASE_URL}/${resource}?${qs}`, {
        method: 'GET',
        credentials: CREDENTIALS_MODE,
    })
        .then(checkStatus)
        .then(parseJSON);
}

//#region Notifications API ------------------------------------------------------------------------
export function getNotification(resource: string): Promise<any> {
    return fetch(`${NOTIFICATION_API}/${resource}`, {
        method: 'GET',
        credentials: CREDENTIALS_MODE,
    })
        .then(checkStatus)
        .then(parseJSON);
}

export function postNotification(resource: string, data: Object): Promise<any> {
    return fetch(`${NOTIFICATION_API}/${resource}`, {
        method: 'POST',
        headers: HEADERS,
        body: JSON.stringify(data),
        credentials: CREDENTIALS_MODE,
    })
        .then(checkStatus)
        .then(parseJSON);
}
//#endregion

function checkStatus(response: Response) {
    if (response.status === 401) {
        redirectToLogin();
    }
    if (response.status >= 400) {
        return parseJSON(response).then((body: { error: string }) => {
            var errorMessage = (body && body.error && body.error.message) || response.statusText;
            var err = createError(response.status, errorMessage);
            throw err;
        });
    }
    return response;
}



// WEBPACK FOOTER //
// ./modules/endpoints.js